import React, { useEffect, useContext, useState, useRef, Suspense } from "react";
import * as survey from "@aidkitorg/types/lib/survey";
import InterfaceContext, { UserInfoContext } from "../../Context";
import { getDistroBrowserIncompatibility } from "../../Util";
import { useParams } from "react-router-dom";

const Distro = React.lazy(() => import("@aidkitorg/typesheets/lib/distroeditor"));

export function MessageTemplateConfig() {
  const { promptId } = useParams<{ promptId?: string }>();
  const context = useContext(InterfaceContext);
  const user = useContext(UserInfoContext);
  const [messageTemplate, setMessageTemplate] = useState<survey.MessageTemplate>({
    kind: "Message Template",
    version: 1,
    name: "",
    description: "",
    instructions: []
  });
  const distroRef = useRef<React.ComponentRef<typeof Distro>>(null);

  useEffect(() => {
    (async () => {
      // Initialize the distro editor with the message template
      distroRef.current?.initialize(messageTemplate, user, undefined, undefined, {}, 
        `We are using a tool to configure message templates for AI conversations. 
         Message templates define the structure and instructions for AI interactions.`
      );
    })()
  }, [user]);

  const incompatible = getDistroBrowserIncompatibility();
  if (incompatible) return incompatible;

  return <div className="bg-gray-100 h-full p-4">
    <h2>Message Template Configuration</h2>
    <div className="mt-4 bg-white shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
      <Suspense>
        <Distro 
          ref={distroRef} 
          value={messageTemplate}
          types='src/survey.ts' 
          name='MessageTemplate' 
          onChange={(v) => {
            setMessageTemplate(v)
          }}
        />
      </Suspense>
    </div>
  </div>;
}